export const pence = (value) => value;
export const supplierCostUnits = (value) => value;
export const rateUnits = (value) => value;
export const ONE_HUNDRED_PERCENT = rateUnits(1000000n);
export const MAX_SAFE_FINANCIAL_UNITS = 9000000000000n;
/** Parse a non-negative decimal string into an exact scaled integer. */
export function parseFixedDecimal(input, decimalPlaces, maximum = MAX_SAFE_FINANCIAL_UNITS) {
    if (!Number.isInteger(decimalPlaces) || decimalPlaces < 0 || decimalPlaces > 12) {
        throw new RangeError('decimalPlaces must be an integer between 0 and 12');
    }
    const value = input.trim();
    if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) {
        throw new TypeError('Value must be a non-negative decimal number');
    }
    const [whole = '0', fraction = ''] = value.startsWith('.') ? ['0', value.slice(1)] : value.split('.');
    if (fraction.length > decimalPlaces)
        throw new RangeError(`Value has more than ${decimalPlaces} decimal places`);
    const scale = 10n ** BigInt(decimalPlaces);
    const units = BigInt(whole) * scale + BigInt((fraction + '0'.repeat(decimalPlaces)).slice(0, decimalPlaces) || '0');
    if (units > maximum)
        throw new RangeError('Value exceeds the supported maximum');
    return units;
}
export function parseFixedDecimalToNumber(input, decimalPlaces, maximum = MAX_SAFE_FINANCIAL_UNITS) {
    const units = parseFixedDecimal(input, decimalPlaces, maximum);
    if (units > BigInt(Number.MAX_SAFE_INTEGER))
        throw new RangeError('Value is not a JSON-safe integer');
    return Number(units);
}
export function formatFixedDecimal(value, decimalPlaces) {
    const units = typeof value === 'number' ? BigInt(value) : value;
    if (units < 0n)
        throw new RangeError('Value must be non-negative');
    const scale = 10n ** BigInt(decimalPlaces);
    const whole = units / scale;
    if (decimalPlaces === 0)
        return whole.toString();
    return `${whole}.${(units % scale).toString().padStart(decimalPlaces, '0')}`;
}
